import { CSSProperties, FC, ReactNode } from 'react'

interface AtomicLinkProps {
  className?: string
  href: string
  target?: string
  children: ReactNode
  onClick?: () => void
  style?: CSSProperties
}

const Link: FC<AtomicLinkProps> = ({
  className,
  href,
  target,
  children,
  onClick,
  style,
}) => {
  return (
    <a
      className={className}
      href={href}
      target={target}
      onClick={onClick}
      style={style}
    >
      {children}
    </a>
  )
}

export default Link
